export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14439.494b37c8.jpg";